import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhoThisFor from "./components/WhoThisFor";
import WhyChooseUs from "./components/WhyChooseUs";
import WhatYoullMaster from "./components/WhatYoullMaster";
import CoursesByLevel from "./components/CoursesByLevel";
import HowItWorks from "./components/HowItWorks";
// import FAQ from "./components/FAQ";
import CmtFaq from "./components/CmtFaq"; // New component import
import Enroll from "./components/Enroll";
import Footer from "./components/Footer";
import SpecialistProfile from "./components/SpecialistProfile"; // Assuming this is a new component for the specialist profile

export default function App() {
  return (
    <div className="app">
      <Navbar />
      <Hero />
      <WhoThisFor />
      <WhyChooseUs />
      <CoursesByLevel />
      <HowItWorks />
      <SpecialistProfile />
      <CmtFaq /> {/* New CMT FAQ section */}
      <Enroll />
      <Footer />
    </div>
  );
}